import O1HD from "../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../BundleResourceConfig";
import { backpackUpdataDialog } from "../config/backpackConst";
import { backPackEventMap } from "../config/BackpackEventConfig";
import NormalGameManager from "../manager/NormalGameManager";
import backpackOpenBase from "./backpackOpenBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class optionalBoxPage extends backpackOpenBase {

    @property({type:cc.Node,tooltip:'itemContent'})
    itemContent:cc.Node = null;

    objAry:string[] = [
        "50013",
        "50014",
        "50015",
        "50016"
    ]

    onBackPackOpenPrefab(...arg){
        NormalGameManager._instance.backpackManager.outOneGood(arg[0].backId);
    }

    start(): void {
        this.loadPage();
    }

    loadPage(){
        this.itemContent.children.forEach((n:cc.Node,index:number)=>{
            let objId:string = this.objAry[index];
            let spNode:cc.Node = n.getChildByName("spf");
            let sp:cc.Sprite = spNode.getComponent(cc.Sprite);
            let backConfig = backPackEventMap()[objId];
            let name = backConfig.name;
            let lbName:cc.Label = n.getChildByName("lbName").getComponent(cc.Label);
            lbName.string = name;
            let spPath:string = backConfig.spPath;
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.backPackGameBundle);
            bundle.load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,sps:cc.SpriteFrame)=>{
                if(err){
                    console.log(err,"加载图片失败");
                    return;
                }
                sp.spriteFrame = sps;
            })
        });
    }

    selectAry:string[] = [];

    selectIndex:number = 0;

    onSelectOne(e:cc.Event.EventTouch){
        let node:cc.Node = e.target;
        let silibingIndex = node.getSiblingIndex();
        if(!this.selectAry.includes(this.objAry[silibingIndex])){
            let oldSelectNode:cc.Node = this.itemContent.children[this.objAry.findIndex((value)=>{
                return value == this.selectAry[this.selectIndex];
            })];
            if(oldSelectNode){
                oldSelectNode.getChildByName("select").active = false;
            }
            this.selectAry[this.selectIndex] = this.objAry[silibingIndex];
            this.selectIndex ++;
            if(this.selectIndex >= 2){
                this.selectIndex = 0;
            }
            node.getChildByName("select").active = true;
        }
    }

    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
       if(this.selectAry.length == 2){
            for(let i = 0;i<this.selectAry.length;i++){
                NormalGameManager._instance.onPushGoods(this.selectAry[i]);
            }
            O1HD.emit(backpackUpdataDialog);
            this.closeThis();
       }else{
            O1HD.getModules().uiControlModule.showMessageBox("请选择两个物品")
       }
    }

    closeThis(){
        this.node.destroy();
    }

}
